import { render, staticRenderFns } from "./Methods.vue?vue&type=template&id=2c08c693&scoped=true&"
import script from "./Methods.vue?vue&type=script&lang=js&"
export * from "./Methods.vue?vue&type=script&lang=js&"
import style0 from "./Methods.vue?vue&type=style&index=0&id=2c08c693&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c08c693",
  null
  
)

export default component.exports